import { Button, Col, Form, Row, Spin } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import WithAuthenticated from "../../components/WithAuthenticated";
import ContentContainer from "../../components/ContentContainer";
import Breadcrumb from "../../components/Breadcrumb";
import TextEditor from "../../components/TextEditor";
import { AboutUs } from "../../interfaces/aboutUs.interface";
import { getAboutUs, updateAboutUs } from "../../api/aboutUs";
import alert from "../../components/AlertMessage";

export interface AboutUsForm {
  detail: string;
}

const Page = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<AboutUs>();
  const [form] = Form.useForm<AboutUsForm>();

  useEffect(() => {
    setLoading(true);
    getAboutUs()
      .then((result) => {
        setData(result);
      })
      .catch(() => {
        alert({
          type: "error",
          content: "Failed to fetch about us.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      detail: data?.detail,
    });
  }, [data, form]);

  const handleFormFinish = (values: AboutUsForm) => {
    setLoading(true);
    updateAboutUs(values)
      .then((result) => {
        setData(result);
      })
      .catch(() => {
        alert({
          type: "error",
          content: "Failed to update about us.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Breadcrumb
        title="About Us"
        items={[{ title: "About Us", location: "" }]}
      />
      <ContentContainer>
        <Row style={{ marginBottom: 20 }}>
          <Col
            style={{ display: "flex", justifyContent: "flex-end" }}
            span={24}
            sm={{ span: 10, offset: 14 }}
            md={{ span: 12, offset: 12 }}
          >
            <Button
              icon={<SaveOutlined />}
              type="primary"
              ghost
              onClick={() => {
                form.submit();
              }}
            >
              Save
            </Button>
          </Col>
        </Row>
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={handleFormFinish}>
            <Form.Item
              name="detail"
              rules={[{ required: true, message: "Input is required!" }]}
            >
              <TextEditor />
            </Form.Item>
          </Form>
        </Spin>
      </ContentContainer>
    </>
  );
};

export default WithAuthenticated(Page);
